module.exports = __webpack_public_path__ + "img/BRCA1_DC.9b734534.png";